<template>
  <div class="activity-page">
    <!-- 顶部标题栏 -->
    <div style="background-color: #fff;padding-bottom: 10px;">
    
      <div class="header">
        <div class="header-left">
          <h1 class="title">精彩活动</h1>
          <span class="tag-count">{{count.total}}场</span>
        </div>
      </div>
  
      <!-- 标签栏 -->
      <div class="tab-bar">
        <div 
          class="tab-item" 
          :class="{ active: activeTab === 1 }" 
          @click="activeTab = 1"
        >
          进行中 <span class="tab-num">{{count.active}}</span>
        </div>
        <div 
          class="tab-item" 
          :class="{ active: activeTab === 2 }" 
          @click="activeTab = 2"
        >
          未开始 <span class="tab-num">{{count.pending}}</span>
        </div>
        <div 
          class="tab-item" 
          :class="{ active: activeTab === 3 }" 
          @click="activeTab = 3"
        >
          已结束 <span class="tab-num">{{count.ended}}</span>
        </div>
      </div>
    </div>

    <!-- 活动列表 -->
    <div class="activity-list">
      <div 
        class="activity-card" 
        v-for="(item, index) in listData" 
        :key="index"
        @click="$router.push(`/activityInfo/${item.id}`)"
      >
        <!-- 图片区域 -->
        <div class="card-img">
          <img :src="item.coverFileId" alt="" />
          <!-- <div class="corner-tag" v-if="item.cornerTag">
            {{ item.cornerTag }}
          </div> -->
          <div class="countdown-tag" v-if="item.countdown">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            {{ item.registrationDeadline }}
          </div>
        </div>

        <!-- 内容区域 -->
        <div class="card-content">
          <div class="card-title-row">
            <h3 class="card-title">{{ item.name }}</h3>
            <span class="status-tag" :class="item.status == 1 ? 'active' : item.status == 2 ? 'pending' : 'ended'">
              {{ item.status ==  1 ? '进行中' : item.status == 2 ? '未开始' : '已结束' }}
            </span>
          </div>
          <div class="info-row">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            <span>{{ item.addressName }}</span>
          </div>
          <div class="bottom-row">
            <div class="time-info">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <span>{{ formatDate(item.startTime) }} - {{ formatDate(item.endTime) }}</span>
            </div>
            <div class="sign-info">
              <!-- <div class="avatars" v-if="item.avatars">
                <img v-for="(a, i) in item.avatars" :key="i" :src="a" class="avatar" />
              </div> -->
              <span class="sign-num" :class="item.signClass">
                {{ item.presentNum }}人已报名
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityPage',
  data() {
    return {
      count:{
        total:0,
        pending:0,
        active:0,
        ended:0
      },
      activeTab: 1, // 1:进行中 2:未开始 3:已结束
      page:1,
      listData: [
        // {
        //     img: 'https://picsum.photos/400/200?random=9',
        //     countdown: '距开始8天',
        //     title: '"寻味江南"美食文化品鉴节',
        //     statusText: '未开始',
        //     statusClass: 'pending',
        //     address: '杭州市 · 上城区河坊街历史街区',
        //     time: '12.20 10:00 - 12.22 20:00',
        //     signCount: 234,
        //     signClass: 'blue'
        //   }
      ],
      // 上拉加载状态
      loading: false,
      noMore: false,
      loadTimer: null 
    }
  },
  mounted () {
    this.getCount()
    this.bindScroll()
    this.getList()
  },
  watch: {
    'activeTab':function(old,val){
      this.resetList()
    }
  },
  beforeDestroy() {
    // 移除滚动监听，防止内存泄漏
    window.removeEventListener('scroll', this.handleScroll)
    // 清除定时器
    if (this.loadTimer) clearTimeout(this.loadTimer)

  },
  methods: {
    getCount(){
      this.$ajax.get('/api/tournament/stats').then((res) => {
        if(res.data.code == 200){
          this.count.total = res.data.data.total
          this.count.active = res.data.data.processing
          this.count.pending = res.data.data.notStarted
          this.count.ended = res.data.data.ended
        }
      })
    },
    // 绑定滚动事件
    bindScroll(){
      window.addEventListener('scroll', this.handleScroll)
    },
    // 滚动处理函数
    handleScroll(){
      
      // 距离底部 100px 触发加载
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const clientHeight = document.documentElement.clientHeight
      const scrollHeight = document.documentElement.scrollHeight
      if (scrollTop <= 300) {
        return // 页面还在顶部，不执行
      }
      if(scrollTop + clientHeight >= scrollHeight - 100){
        // 防抖：清除之前的定时器
        if (this.loadTimer) clearTimeout(this.loadTimer)

        // 延迟 300ms 再请求，防止疯狂触发
        if(!this.noMore){
          this.loadTimer = setTimeout(() => {
            this.getList()
          }, 300)
        }
      }
    },
    getList(){
      this.$ajax.get('/api/tournament/list',{
        params:{
          current:this.page,
          status:this.activeTab,
        }
      }).then((res) => {
        if(res.data.code == 200){
          this.listData = this.listData.concat(res.data.data.records)
          if(res.data.data.records.length<10){
            this.noMore = true
          }else{
            this.page++
          }
        }
      })
    },
    resetList(){
      this.page = 1
      this.listData = []
      this.noMore = false
      window.scrollTo(0, 0)
      this.getList()
    },
    formatDate(time) {
      if (!time) return ''
      return String(time).split('T')[0].split(' ')[0]
    },
  }
}
</script>

<style scoped>
.activity-page {
  background-color: #f6f7fa;
  min-height: 100vh;
}

/* 顶部标题栏 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px 10px;
  background-color: #fff;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.title {
  font-size: 18px;
  font-weight: bold;
  color: #1a1a1a;
}
.tag-count {
  background: #ff7d00;
  color: #fff;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 12px;
}
.header-right {
  display: flex;
  gap: 20px;
}
.icon-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.red-dot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 8px;
  height: 8px;
  background: #ff4d4f;
  border-radius: 50%;
}

/* 标签栏 */
.tab-bar {
  display: flex;
  background: #f5f7fa;
  border-radius: 12px;
  margin: 0 16px;
  padding: 4px;
  margin-bottom: 10px;
  
}
.tab-item {
  flex: 1;
  text-align: center;
  padding: 9px 0;
  border-radius: 8px;
  font-size: 12px;
  color: #999;
}
.tab-item.active {
  background: #fff;
  color: #ff7d00;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.tab-num {
  margin-left: 4px;
  color: inherit;
}

/* 活动列表 */
.activity-list {
  padding: 10px 14px;
  background-color: #f6f7fa;
}
.activity-card {
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 12px;
}
.card-img {
  position: relative;
  height: 132px;
}
.card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.corner-tag {
  position: absolute;
  top: 12px;
  left: 0;
  background: #ff4d4f;
  color: #fff;
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 0 12px 12px 0;
}
.countdown-tag {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(0,0,0,0.6);
  color: #fff;
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* 卡片内容 */
.card-content {
  padding: 12px;
}
.card-title-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}
.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  flex: 1;
  padding-right: 8px;
}
.status-tag {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 12px;
}
.status-tag.active {
  background: #fff7e6;
  color: #ff7d00;
}
.status-tag.pending {
  background: #e6f7ff;
  color: #1677ff;
}
.status-tag.ended {
  background: #f5f5f5;
  color: #999;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
}
.bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.time-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #666;
}
.sign-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.avatars {
  display: flex;
}
.avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-left: -8px;
}
.sign-num {
  font-size: 12px;
  font-weight: 500;
}
.sign-num.orange {
  color: #ff7d00;
}
.sign-num.blue {
  color: #1677ff;
}
.sign-num.gray {
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/activity/list.vue